import axios from 'axios';
import { domain } from './domain'

export const createCompanyTransaction = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company-transaction`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const getCompanyTransactions = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/get`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const getTransactionsSummary = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/summary`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};


export const getCompanyClosures = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/closures`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};


export const getCompanyMonthlyData = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/monthlydata`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const correctTransaction = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/correct`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const getOxyTransactions = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    };
    return axios(`${domain}/company-transaction/oxy`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};